import { CertificationType } from '../../../../../types/ResumeTypes';

import C from '../ViewerMode.module.scss';
import ResumeInfoPeriod from '../../../../common/ResumeInfoPeriod/index';

interface CertificationViewerProps {
  certifications: CertificationType[];
}
const CertificationViewer = (props: CertificationViewerProps) => {
  const { certifications } = props;

  if (certifications === undefined || certifications.length === 0) {
    return null;
  }

  return (
    <>
      <section className={`${C.viewer_section} wrapper`}>
        <h4 className={`${C.section_title} h4`}>자격사항</h4>
        {certifications?.map((certification, index) => {
          return (
            <CertificationElementViewer
              certification={certification}
              key={`certification-viewer-${index}`}
            />
          );
        })}
      </section>
      <hr />
    </>
  );
};

interface CertificationElementViewerProps {
  certification: CertificationType;
}

const CertificationElementViewer = (props: CertificationElementViewerProps) => {
  const { certification } = props;
  return (
    <>
      {/* 개별 박스 */}
      <article className={`${C.common_box} vertical-center`}>
        {/* 기간 */}
        <ResumeInfoPeriod text={''} startDate={certification.at || ''} endDate={''} />
        {/* 상세 내용 */}
        <div className={`${C.profile_text_wrap}`}>
          <div className={`${C.profile_text_line}`}>
            <div className={C.text_el_wrap}>
              <h2 className="h2">{certification.name || ''}</h2>
              <span className="divided-line" />
              <h4 className="h4">{certification.grade || ''}</h4>
            </div>
          </div>
          <div className={C.profile_text_line}>
            <div className={C.text_el_wrap}>
              <h4 className="b1">{certification.institution || ''}</h4>
            </div>
          </div>
        </div>
      </article>
      {/* 개별 박스 */}
      {/*<article className={`${C.common_box} vertical-center`}>*/}
      {/*  /!* 기간 *!/*/}
      {/*  <ResumeInfoPeriod text="" startDate="2020.10" endDate="" />*/}
      {/*  /!* 상세 내용 *!/*/}
      {/*  <div className={`${C.profile_text_wrap}`}>*/}
      {/*    <div className={`${C.profile_text_line}`}>*/}
      {/*      <div className={C.text_el_wrap}>*/}
      {/*        <h2 className="h2">시험명</h2>*/}
      {/*        <span className="divided-line" />*/}
      {/*        <h4 className="h4">발급기관</h4>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</article>*/}
    </>
  );
};

export default CertificationViewer;
